// import Modal from "@/components/Modal";
// import PdfViewer from "@/components/PdfViewer";
// import SkeletonRow from "@/components/SkeletonRow";
// import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
// import { Badge } from "@/components/ui/badge";
// import { Button } from "@/components/ui/button";
// import {
//   Tooltip,
//   TooltipContent,
//   TooltipProvider,
//   TooltipTrigger,
// } from "@/components/ui/tooltip";
// import useDataPendaftaran from "@/hooks/useDataPendaftaran";
// import useDataStep from "@/hooks/useDataStep";
// import useSessionStorage from "@/hooks/useSessionStorage";
// import useTimePeriode from "@/hooks/useTimePeriode";
// import { getListBerkasPenerimaan } from "@/services/getData";
// import { DataBerkas, SysBerkas } from "@/types";
// import { useQuery } from "@tanstack/react-query";
// import {
//   AlertTriangle,
//   CheckCircle2,
//   Download,
//   Eye,
//   FileText,
//   GraduationCap,
//   Info,
//   Trash2,
//   Upload,
// } from "lucide-react";
// import { useState } from "react";
// import Form from "./Form";
// import useScreen from "@/hooks/useScreen";

// export default function UnggahBerkas({
//   idDataPendaftaran,
// }: {
//   idDataPendaftaran: string;
// }) {
//   const [sessionPeriode] = useSessionStorage("sessionPeriode", {
//     id_sys_periode: "",
//   });

//   const {isMobile} = useScreen()
//   const { timePassedActive } = useTimePeriode();
//   const { isSudahFinalisasi, isValidasiPendaftaran } = useDataStep();
//   const { dataPendaftaran } = useDataPendaftaran();
//   const isKIPK = !!dataPendaftaran?.no_kipk;

//   const [showUpload, setShowUpload] = useState(false);
//   const [showDelete, setShowDelete] = useState(false);
//   const [showPdf, setShowPdf] = useState(false);
//   const [selectedRow, setSelectedRow] = useState<SysBerkas | null>(null);
//   const [selectedBerkas, setSelectedBerkas] = useState<DataBerkas | null>(null);

//   const { data, isPending } = useQuery({
//     queryKey: ["listDataBerkasPenerimaan", sessionPeriode?.id_sys_periode],
//     queryFn: () =>
//       getListBerkasPenerimaan(sessionPeriode?.id_sys_periode || ""),
//   });

//   const listBerkasPenunjangKIPK = data?.listSysBerkas
//     ? data?.listSysBerkas?.filter((sysBerkas: SysBerkas) => {
//         return sysBerkas.jenis_berkas?.is_penunjang_kipk;
//       })
//     : [];

//   const isDisableInput =
//     isSudahFinalisasi ||
//     isValidasiPendaftaran ||
//     timePassedActive?.waktu_selesai_daftar_valid_selesai;

//   return (
//     <div className="space-y-6 animate-in fade-in duration-500">
//       {/* HEADER & ALERTS */}
//       <div className="space-y-4">
//         <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
//           <FileText className="w-6 h-6 text-blue-600 dark:text-blue-400" />
//           Kelengkapan Berkas
//         </h1>

//         <Alert className="bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-800 text-amber-900 dark:text-amber-200">
//           <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
//           <AlertTitle className="font-bold text-amber-800 dark:text-amber-300">
//             Perhatian
//           </AlertTitle>
//           <AlertDescription className="text-sm mt-1">
//             Pastikan dokumen yang diunggah terbaca jelas, tidak terpotong, dan
//             sesuai format yang ditentukan. Dokumen ini akan divalidasi oleh
//             panitia.
//           </AlertDescription>
//         </Alert>

//         {isKIPK && listBerkasPenunjangKIPK.length > 0 && (
//           <div className="bg-gradient-to-r from-indigo-50 to-blue-50 dark:from-indigo-900/20 dark:to-blue-900/20 border border-indigo-100 dark:border-indigo-800 rounded-xl p-5 shadow-sm relative overflow-hidden">
//             <div className="flex items-start gap-4 relative z-10">
//               <div className="p-2 bg-white dark:bg-indigo-950 rounded-lg shadow-sm text-indigo-600 dark:text-indigo-400">
//                 <GraduationCap className="w-6 h-6" />
//               </div>
//               <div className="flex-1">
//                 <h3 className="text-lg font-bold text-indigo-900 dark:text-indigo-100 mb-2">
//                   Peserta KIP Kuliah
//                 </h3>
//                 <p className="text-sm text-indigo-800 dark:text-indigo-200 mb-3 leading-relaxed">
//                   Tingkatkan peluang lolos seleksi dengan melengkapi berkas
//                   penunjang berikut:
//                 </p>
//                 <div className="flex flex-wrap gap-2">
//                   {listBerkasPenunjangKIPK.map((berkas: SysBerkas) => (
//                     <Badge
//                       key={berkas.id_sys_berkas}
//                       variant="secondary"
//                       className="bg-white/60 dark:bg-black/20 text-indigo-700 dark:text-indigo-300 border-indigo-200"
//                     >
//                       {berkas.keterangan_berkas}
//                     </Badge>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* TABLE SECTION */}
//       {isPending ? (
//         <div className="space-y-3">
//           {[1, 2, 3, 4, 5].map((i) => (
//             <SkeletonRow key={i} />
//           ))}
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm text-left">
//               <thead className="text-xs text-slate-500 uppercase bg-slate-50 dark:bg-slate-950 dark:text-slate-400 border-b border-slate-200 dark:border-slate-800">
//                 <tr>
//                   <th className="px-4 py-3 w-12 text-center">#</th>
//                   <th className="px-4 py-3 min-w-[200px]">Dokumen</th>
//                   <th className="px-4 py-3 min-w-[250px]">Keterangan</th>
//                   <th className="px-4 py-3 w-32 text-center">Contoh</th>
//                   <th className="px-4 py-3 w-32 text-center">Status</th>
//                   <th className="px-4 py-3 w-40 text-center">Aksi</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
//                 {data?.listSysBerkas?.map((row: SysBerkas, index: number) => {
//                   const berkasSiswa: DataBerkas | undefined =
//                     data?.listDataBerkasSiswa.find(
//                       (berkas: DataBerkas) =>
//                         berkas?.id_sys_berkas == String(row.id_sys_berkas),
//                     );
//                   const isUploaded = !!berkasSiswa;

//                   return (
//                     <tr
//                       key={row.id_sys_berkas}
//                       className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
//                     >
//                       <td className="px-4 py-3 text-center text-slate-400 font-mono">
//                         {index + 1}
//                       </td>

//                       {/* Nama Dokumen */}
//                       <td className="px-4 py-3">
//                         <div className="font-semibold text-slate-800 dark:text-slate-200">
//                           {row.jenis_berkas?.nama_jenis_berkas}
//                         </div>
//                         {row.is_wajib ? (
//                           <Badge variant={"destructive"}>Wajib</Badge>
//                         ) : (
//                           ""
//                         )}
//                       </td>

//                       {/* Keterangan */}
//                       <td className="px-4 py-3 text-slate-500 dark:text-slate-400 text-xs leading-relaxed">
//                         {row?.keterangan_berkas || "-"}
//                       </td>

//                       {/* Format Download */}
//                       <td className="px-4 py-3 text-center">
//                         {row.url_template_berkas ? (
//                           <TooltipProvider>
//                             <Tooltip>
//                               <TooltipTrigger asChild>
//                                 <Button
//                                   variant="outline"
//                                   size="sm"
//                                   className="h-7 text-xs border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400"
//                                   onClick={() =>
//                                     window.open(
//                                       `${row.url_template_berkas}?id_sys_periode=${sessionPeriode?.id_sys_periode}`,
//                                       "_blank",
//                                     )
//                                   }
//                                 >
//                                   <Download className="w-3 h-3 mr-1.5" /> Unduh
//                                 </Button>
//                               </TooltipTrigger>
//                               <TooltipContent>
//                                 Unduh template dokumen
//                               </TooltipContent>
//                             </Tooltip>
//                           </TooltipProvider>
//                         ) : (
//                           <span className="text-slate-300 text-xs">-</span>
//                         )}
//                       </td>

//                       {/* Status Upload */}
//                       <td className="px-4 py-3 text-center">
//                         {isUploaded ? (
//                           <Badge className="bg-emerald-100 hover:bg-emerald-100 text-emerald-700 border-emerald-200 shadow-none dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-800">
//                             <CheckCircle2 className="w-3 h-3 mr-1" />
//                             Ada
//                           </Badge>
//                         ) : (
//                           <Badge
//                             variant="outline"
//                             className="text-slate-500 border-slate-200 bg-slate-50 dark:bg-slate-900 dark:border-slate-700"
//                           >
//                             <Info className="w-3 h-3 mr-1" />
//                             Kosong
//                           </Badge>
//                         )}
//                       </td>

//                       {/* Aksi Group */}
//                       <td className="px-4 py-3">
//                         <div className="flex items-center justify-center gap-2">
//                           {/* Tombol Lihat (Hanya jika uploaded) */}
//                           {isUploaded && (
//                             <TooltipProvider>
//                               <Tooltip>
//                                 <TooltipTrigger asChild>
//                                   <Button
//                                     variant="secondary"
//                                     size="sm"
//                                     className="h-8 w-8 p-0 bg-blue-50 text-blue-600 hover:bg-blue-100 dark:bg-blue-900/20 dark:text-blue-400"
//                                     onClick={() => {
//                                       setShowPdf(true);
//                                       setSelectedRow(row);
//                                       setSelectedBerkas(berkasSiswa);
//                                     }}
//                                   >
//                                     <Eye className="w-4 h-4" />
//                                   </Button>
//                                 </TooltipTrigger>
//                                 <TooltipContent>Lihat Berkas</TooltipContent>
//                               </Tooltip>
//                             </TooltipProvider>
//                           )}

//                           {/* Tombol Upload / Ganti */}
//                           {!isDisableInput && (
//                             <TooltipProvider>
//                               <Tooltip>
//                                 <TooltipTrigger asChild>
//                                   <Button
//                                     size={isUploaded ? "sm" : "sm"}
//                                     className={`h-8 ${
//                                       isUploaded
//                                         ? "w-8 p-0 bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300"
//                                         : "px-3 text-xs font-medium"
//                                     }`}
//                                     onClick={() => {
//                                       setShowUpload(true);
//                                       setSelectedRow(row);
//                                       setSelectedBerkas(berkasSiswa || null);
//                                     }}
//                                   >
//                                     <Upload className="w-4 h-4" />
//                                     {!isUploaded && (
//                                       <span className="ml-1.5">Upload</span>
//                                     )}
//                                   </Button>
//                                 </TooltipTrigger>
//                                 <TooltipContent>
//                                   {isUploaded
//                                     ? "Ganti Berkas"
//                                     : "Upload Berkas"}
//                                 </TooltipContent>
//                               </Tooltip>
//                             </TooltipProvider>
//                           )}

//                           {/* Tombol Hapus */}
//                           {!isDisableInput && isUploaded && (
//                             <TooltipProvider>
//                               <Tooltip>
//                                 <TooltipTrigger asChild>
//                                   <Button
//                                     variant="ghost"
//                                     size="sm"
//                                     className="h-8 w-8 p-0 text-rose-500 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-900/20"
//                                     onClick={() => {
//                                       setShowDelete(true);
//                                       setSelectedRow(row);
//                                       setSelectedBerkas(berkasSiswa);
//                                     }}
//                                   >
//                                     <Trash2 className="w-4 h-4" />
//                                   </Button>
//                                 </TooltipTrigger>
//                                 <TooltipContent>Hapus Berkas</TooltipContent>
//                               </Tooltip>
//                             </TooltipProvider>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {/* --- MODALS (Tetap sama) --- */}
//       <Modal
//         show={showUpload}
//         onClose={() => setShowUpload(false)}
//         className="md:w-[32rem]"
//       >
//         <Form
//           method="POST"
//           selectedRow={selectedRow}
//           selectedBerkas={selectedBerkas}
//           closeModal={() => setShowUpload(false)}
//           idDataPendaftaran={idDataPendaftaran}
//         />
//       </Modal>

//       <Modal show={showDelete} onClose={() => setShowDelete(false)}>
//         <Form
//           method="DELETE"
//           selectedBerkas={selectedBerkas}
//           selectedRow={selectedRow}
//           closeModal={() => setShowDelete(false)}
//         />
//       </Modal>

//       <Modal
//         show={showPdf}
//         onClose={() => {
//           setShowPdf(false);
//           // Optional: clear selected setelah delay animasi
//           setTimeout(() => setSelectedBerkas(null), 300);
//         }}
//         className="lg:w-[60vw] w-[95vw]"
//       >
//         <div className="flex flex-col gap-4 p-2">
//           <div>
//             <h1 className="font-bold text-lg text-slate-900 dark:text-white">
//               {selectedBerkas?.sys_berkas?.jenis_berkas?.nama_jenis_berkas}
//             </h1>
//             {selectedBerkas?.nomor && (
//               <Badge className="mt-2 bg-blue-100 text-blue-700 hover:bg-blue-100 dark:bg-blue-900/30 dark:text-blue-300">
//                 Nomor: {selectedBerkas?.nomor}
//               </Badge>
//             )}
//           </div>

//           {/* Panggil komponen PdfViewer */}
//           {showPdf && selectedBerkas?.path_berkas && (
//             <PdfViewer url={selectedBerkas.path_berkas} />
//           )}
//         </div>
//       </Modal>
//     </div>
//   );
// }

import Modal from "@/components/Modal";
import PdfViewer from "@/components/PdfViewer";
import SkeletonRow from "@/components/SkeletonRow";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import useDataPendaftaran from "@/hooks/useDataPendaftaran";
import useDataStep from "@/hooks/useDataStep";
import useSessionStorage from "@/hooks/useSessionStorage";
import useTimePeriode from "@/hooks/useTimePeriode";
import { getListBerkasPenerimaan } from "@/services/getData";
import { DataBerkas, SysBerkas } from "@/types";
import { useQuery } from "@tanstack/react-query";
import {
  AlertTriangle,
  CheckCircle2,
  Download,
  Eye,
  FileText,
  GraduationCap,
  Info,
  Trash2,
  Upload,
} from "lucide-react";
import { useState } from "react";
import Form from "./Form";
import useScreen from "@/hooks/useScreen";

export default function UnggahBerkas({
  idDataPendaftaran,
}: {
  idDataPendaftaran: string;
}) {
  const [sessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  });

  const { isMobile } = useScreen();
  const { timePassedActive } = useTimePeriode();
  const { isSudahFinalisasi, isValidasiPendaftaran } = useDataStep();
  const { dataPendaftaran } = useDataPendaftaran();
  const isKIPK = !!dataPendaftaran?.no_kipk;

  const [showUpload, setShowUpload] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [selectedRow, setSelectedRow] = useState<SysBerkas | null>(null);
  const [selectedBerkas, setSelectedBerkas] = useState<DataBerkas | null>(null);

  const { data, isPending } = useQuery({
    queryKey: ["listDataBerkasPenerimaan", sessionPeriode?.id_sys_periode],
    queryFn: () =>
      getListBerkasPenerimaan(sessionPeriode?.id_sys_periode || ""),
  });

  const listBerkasPenunjangKIPK = data?.listSysBerkas
    ? data?.listSysBerkas?.filter((sysBerkas: SysBerkas) => {
        return sysBerkas.jenis_berkas?.is_penunjang_kipk;
      })
    : [];

  const isDisableInput =
    isSudahFinalisasi ||
    isValidasiPendaftaran ||
    timePassedActive?.waktu_selesai_daftar_valid_selesai;

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      {/* HEADER & ALERTS (Tetap Sama) */}
      <div className="space-y-4">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
          <FileText className="w-6 h-6 text-blue-600 dark:text-blue-400" />
          Kelengkapan Berkas
        </h1>

        <Alert className="bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-800 text-amber-900 dark:text-amber-200">
          <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
          <AlertTitle className="font-bold text-amber-800 dark:text-amber-300">
            Perhatian
          </AlertTitle>
          <AlertDescription className="text-sm mt-1">
            Pastikan dokumen yang diunggah terbaca jelas, tidak terpotong, dan
            sesuai format yang ditentukan. Dokumen ini akan divalidasi oleh
            panitia.
          </AlertDescription>
        </Alert>

        {isKIPK && listBerkasPenunjangKIPK.length > 0 && (
          <div className="bg-gradient-to-r from-indigo-50 to-blue-50 dark:from-indigo-900/20 dark:to-blue-900/20 border border-indigo-100 dark:border-indigo-800 rounded-xl p-5 shadow-sm relative overflow-hidden">
            <div className="flex items-start gap-4 relative z-10">
              <div className="p-2 bg-white dark:bg-indigo-950 rounded-lg shadow-sm text-indigo-600 dark:text-indigo-400">
                <GraduationCap className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-indigo-900 dark:text-indigo-100 mb-2">
                  Peserta KIP Kuliah
                </h3>
                <p className="text-sm text-indigo-800 dark:text-indigo-200 mb-3 leading-relaxed">
                  Tingkatkan peluang lolos seleksi dengan melengkapi berkas
                  penunjang berikut:
                </p>
                <div className="flex flex-wrap gap-2">
                  {listBerkasPenunjangKIPK.map((berkas: SysBerkas) => (
                    <Badge
                      key={berkas.id_sys_berkas}
                      variant="secondary"
                      className="bg-white/60 dark:bg-black/20 text-indigo-700 dark:text-indigo-300 border-indigo-200"
                    >
                      {berkas.keterangan_berkas}
                    </Badge>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* BERKAS LIST SECTION */}
      {isPending ? (
        <div className="space-y-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <SkeletonRow key={i} />
          ))}
        </div>
      ) : isMobile ? (
        /* ====================================================
           UI MOBILE: CARD / GRID LAYOUT
           ==================================================== */
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {data?.listSysBerkas?.map((row: SysBerkas, index: number) => {
            const berkasSiswa: DataBerkas | undefined =
              data?.listDataBerkasSiswa.find(
                (berkas: DataBerkas) =>
                  berkas?.id_sys_berkas == String(row.id_sys_berkas),
              );
            const isUploaded = !!berkasSiswa;

            return (
              <div
                key={row.id_sys_berkas}
                className={`flex flex-col bg-white dark:bg-slate-900 border rounded-xl p-4 shadow-sm relative overflow-hidden transition-all ${
                  isUploaded
                    ? "border-emerald-200 dark:border-emerald-800/50"
                    : "border-slate-200 dark:border-slate-800"
                }`}
              >
                {/* Indikator Samping Jika Wajib tapi Belum Upload */}
                {row.is_wajib && !isUploaded && (
                  <div className="absolute top-0 left-0 bottom-0 w-1 bg-amber-500" />
                )}

                {/* Card Header */}
                <div className="flex justify-between items-start gap-3">
                  <div>
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className="text-xs font-bold text-slate-400 bg-slate-100 dark:bg-slate-800 px-1.5 py-0.5 rounded">
                        #{index + 1}
                      </span>
                      {isUploaded ? (
                        <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100 dark:bg-emerald-900/30 dark:text-emerald-400 shadow-none border-none h-5 text-[10px]">
                          <CheckCircle2 className="w-3 h-3 mr-1" /> Ada
                        </Badge>
                      ) : (
                        <Badge
                          variant="outline"
                          className="text-slate-500 h-5 text-[10px]"
                        >
                          <Info className="w-3 h-3 mr-1" /> Kosong
                        </Badge>
                      )}
                      {row.is_wajib && (
                        <Badge
                          variant="destructive"
                          className="h-5 text-[10px]"
                        >
                          Wajib
                        </Badge>
                      )}
                    </div>
                    <h4 className="font-bold text-slate-800 dark:text-slate-200 text-sm leading-tight">
                      {row.jenis_berkas?.nama_jenis_berkas}
                    </h4>
                  </div>
                </div>

                {/* Keterangan */}
                <p className="text-xs text-slate-500 dark:text-slate-400 mt-2 mb-4 leading-relaxed">
                  {row?.keterangan_berkas || "-"}
                </p>

                {/* Card Footer / Actions */}
                <div className="mt-auto pt-3 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between gap-2">
                  {row.url_template_berkas ? (
                    <Button
                      variant="outline"
                      size="sm"
                      className="h-8 text-[10px] px-2"
                      onClick={() =>
                        window.open(
                          `${row.url_template_berkas}?id_sys_periode=${sessionPeriode?.id_sys_periode}`,
                          "_blank",
                        )
                      }
                    >
                      <Download className="w-3 h-3 mr-1" /> Template
                    </Button>
                  ) : (
                    <div /> /* Spacer */
                  )}

                  <div className="flex items-center gap-1.5">
                    {isUploaded && (
                      <Button
                        variant="secondary"
                        size="sm"
                        className="h-8 px-2.5 text-[10px] bg-blue-50 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400"
                        onClick={() => {
                          setShowPdf(true);
                          setSelectedRow(row);
                          setSelectedBerkas(berkasSiswa);
                        }}
                      >
                        <Eye className="w-3.5 h-3.5 mr-1.5" /> Lihat
                      </Button>
                    )}

                    {!isDisableInput && (
                      <Button
                        size="sm"
                        className={`h-8 px-3 text-[10px] ${
                          isUploaded
                            ? "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300"
                            : ""
                        }`}
                        onClick={() => {
                          setShowUpload(true);
                          setSelectedRow(row);
                          setSelectedBerkas(berkasSiswa || null);
                        }}
                      >
                        <Upload className="w-3.5 h-3.5 mr-1.5" />
                        {isUploaded ? "Ganti" : "Upload"}
                      </Button>
                    )}

                    {!isDisableInput && isUploaded && (
                      <Button
                        variant="ghost"
                        size="sm"
                        className="h-8 w-8 p-0 text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 shrink-0"
                        onClick={() => {
                          setShowDelete(true);
                          setSelectedRow(row);
                          setSelectedBerkas(berkasSiswa);
                        }}
                      >
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        /* ====================================================
           UI DESKTOP: TABLE LAYOUT
           ==================================================== */
        <div className="grid grid-cols-1 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="text-xs text-slate-500 uppercase bg-slate-50 dark:bg-slate-950 dark:text-slate-400 border-b border-slate-200 dark:border-slate-800">
                <tr>
                  <th className="px-4 py-3 w-12 text-center">#</th>
                  <th className="px-4 py-3 min-w-[200px]">Dokumen</th>
                  <th className="px-4 py-3 min-w-[250px]">Keterangan</th>
                  <th className="px-4 py-3 w-32 text-center">Contoh</th>
                  <th className="px-4 py-3 w-32 text-center">Status</th>
                  <th className="px-4 py-3 w-40 text-center">Aksi</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                {data?.listSysBerkas?.map((row: SysBerkas, index: number) => {
                  const berkasSiswa: DataBerkas | undefined =
                    data?.listDataBerkasSiswa.find(
                      (berkas: DataBerkas) =>
                        berkas?.id_sys_berkas == String(row.id_sys_berkas),
                    );
                  const isUploaded = !!berkasSiswa;

                  return (
                    <tr
                      key={row.id_sys_berkas}
                      className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
                    >
                      <td className="px-4 py-3 text-center text-slate-400 font-mono">
                        {index + 1}
                      </td>

                      <td className="px-4 py-3">
                        <div className="font-semibold text-slate-800 dark:text-slate-200">
                          {row.jenis_berkas?.nama_jenis_berkas}
                        </div>
                        {row.is_wajib && (
                          <Badge variant="destructive" className="mt-1">
                            Wajib
                          </Badge>
                        )}
                      </td>

                      <td className="px-4 py-3 text-slate-500 dark:text-slate-400 text-xs leading-relaxed">
                        {row?.keterangan_berkas || "-"}
                      </td>

                      <td className="px-4 py-3 text-center">
                        {row.url_template_berkas ? (
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="h-7 text-xs border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400"
                                  onClick={() =>
                                    window.open(
                                      `${row.url_template_berkas}?id_sys_periode=${sessionPeriode?.id_sys_periode}`,
                                      "_blank",
                                    )
                                  }
                                >
                                  <Download className="w-3 h-3 mr-1.5" /> Unduh
                                </Button>
                              </TooltipTrigger>
                              <TooltipContent>
                                Unduh template dokumen
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        ) : (
                          <span className="text-slate-300 text-xs">-</span>
                        )}
                      </td>

                      <td className="px-4 py-3 text-center">
                        {isUploaded ? (
                          <Badge className="bg-emerald-100 hover:bg-emerald-100 text-emerald-700 border-emerald-200 shadow-none dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-800">
                            <CheckCircle2 className="w-3 h-3 mr-1" />
                            Ada
                          </Badge>
                        ) : (
                          <Badge
                            variant="outline"
                            className="text-slate-500 border-slate-200 bg-slate-50 dark:bg-slate-900 dark:border-slate-700"
                          >
                            <Info className="w-3 h-3 mr-1" />
                            Kosong
                          </Badge>
                        )}
                      </td>

                      <td className="px-4 py-3">
                        <div className="flex items-center justify-center gap-2">
                          {isUploaded && (
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <Button
                                    variant="secondary"
                                    size="sm"
                                    className="h-8 w-8 p-0 bg-blue-50 text-blue-600 hover:bg-blue-100 dark:bg-blue-900/20 dark:text-blue-400"
                                    onClick={() => {
                                      setShowPdf(true);
                                      setSelectedRow(row);
                                      setSelectedBerkas(berkasSiswa);
                                    }}
                                  >
                                    <Eye className="w-4 h-4" />
                                  </Button>
                                </TooltipTrigger>
                                <TooltipContent>Lihat Berkas</TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          )}

                          {!isDisableInput && (
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <Button
                                    size="sm"
                                    className={`h-8 ${
                                      isUploaded
                                        ? "w-8 p-0 bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300"
                                        : "px-3 text-xs font-medium"
                                    }`}
                                    onClick={() => {
                                      setShowUpload(true);
                                      setSelectedRow(row);
                                      setSelectedBerkas(berkasSiswa || null);
                                    }}
                                  >
                                    <Upload className="w-4 h-4" />
                                    {!isUploaded && (
                                      <span className="ml-1.5">Upload</span>
                                    )}
                                  </Button>
                                </TooltipTrigger>
                                <TooltipContent>
                                  {isUploaded
                                    ? "Ganti Berkas"
                                    : "Upload Berkas"}
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          )}

                          {!isDisableInput && isUploaded && (
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <Button
                                    variant="ghost"
                                    size="sm"
                                    className="h-8 w-8 p-0 text-rose-500 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-900/20"
                                    onClick={() => {
                                      setShowDelete(true);
                                      setSelectedRow(row);
                                      setSelectedBerkas(berkasSiswa);
                                    }}
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </Button>
                                </TooltipTrigger>
                                <TooltipContent>Hapus Berkas</TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* --- MODALS (Tetap Sama) --- */}
      <Modal
        show={showUpload}
        onClose={() => setShowUpload(false)}
        className="md:w-[32rem]"
      >
        <Form
          method="POST"
          selectedRow={selectedRow}
          selectedBerkas={selectedBerkas}
          closeModal={() => setShowUpload(false)}
          idDataPendaftaran={idDataPendaftaran}
        />
      </Modal>

      <Modal show={showDelete} onClose={() => setShowDelete(false)}>
        <Form
          method="DELETE"
          selectedBerkas={selectedBerkas}
          selectedRow={selectedRow}
          closeModal={() => setShowDelete(false)}
        />
      </Modal>

      <Modal
        show={showPdf}
        onClose={() => {
          setShowPdf(false);
          setTimeout(() => setSelectedBerkas(null), 300);
        }}
        className="lg:w-[60vw] w-[95vw]"
      >
        <div className="flex flex-col gap-4 p-2">
          <div>
            <h1 className="font-bold text-lg text-slate-900 dark:text-white">
              {selectedBerkas?.sys_berkas?.jenis_berkas?.nama_jenis_berkas}
            </h1>
            {selectedBerkas?.nomor && (
              <Badge className="mt-2 bg-blue-100 text-blue-700 hover:bg-blue-100 dark:bg-blue-900/30 dark:text-blue-300">
                Nomor: {selectedBerkas?.nomor}
              </Badge>
            )}
          </div>
          {showPdf && selectedBerkas?.path_berkas && (
            <PdfViewer url={selectedBerkas.path_berkas} />
          )}
        </div>
      </Modal>
    </div>
  );
}
